import slideToggle from "../../../js/modules/slideToggle.js";

const verticalMenu = () => {
    // Обработчик клика по кнопке элемента меню
    document.querySelectorAll('.vertical-menu__item-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();

            const menuItem = e.currentTarget.closest('.vertical-menu__item');
            const subMenu = menuItem.querySelector('.vertical-menu__submenu');

            // Переключаем видимость подменю
            /*
              Состояния пункта меню:
              - Если у пункта меню есть оба класса "selected" и "active" - то находимся в разделе, имеющем подразделы
              - Если у пункта меню один класс "active" - мы находимся в дочернем разделе,
              родитель которого имеет подразделы
             */
            subMenu.slideToggle(200, () => {
                const isActive = menuItem.classList.contains('vertical-menu__item_active');
                const isSelectedAndActive = menuItem.classList.contains('vertical-menu__item_selected') && isActive;

                if (isSelectedAndActive) {
                    // подставлять класс submenu-btn-hide,
                    // при котором стрелка свернута
                    btn.classList.toggle('vertical-menu__item-btn_hide');
                } else {
                    // если мы не находимся в разделе или подразделе этого пункта
                    // меню, то подставлять класс submenu-btn-show, при котором стрелка развернута
                    btn.classList.toggle('vertical-menu__item-btn_show');
                }
            });
        });
    });

    // Обработчик клика по переключателю подменю
    document.querySelectorAll('.vertical-menu .submenu-toggle').forEach(toggle => {
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            const itemWrap = e.currentTarget.closest('.vertical-menu__item-wrap');
            const itemBtn = itemWrap.querySelector('.vertical-menu__item-btn');
            itemBtn?.click();
        });
    });
};

export default verticalMenu;